<ng-hbm-bdi-loader *ngIf="loader"></ng-hbm-bdi-loader>

<div class="row" *ngIf="!loader">
    <div class="qrcode">
        <qrcode class="qrcodeHeight hidden-object" [elementType]="'img'" [qrdata]="qrCodeData" [width]="280"
            [errorCorrectionLevel]="'M'" [allowEmptyString]="true"></qrcode>
    </div>
    <div class="signature-container">
        <div class="signature hidden-object">
            <p class="signature-indication">{{ 'popins.products_list.signature.firstname' | translate }}..................................................................................................</p>
            <p class="signature-indication">{{ 'popins.products_list.signature.name' | translate }}...............................................................................................</p>
            <p class="signature-indication">{{ 'popins.products_list.signature.dni' | translate }}............................................</p>
            <p class="signature-indication">{{ 'popins.products_list.signature.accept' | translate }}</p>
            <div class="signature-sub-container">
            </div>
        </div>
        
    </div>

    <div class="col-3">
        <div class="col-left p-3 pt-5 p-xl-4 pt-xl-5 purchase-list-aside">
            <h2>{{ 'popins.products_list.title' | translate }}</h2>
            <p class="info">{{ 'popins.products_list.customer_id' | translate }} {{ customerInfos.id }}
            <p class="info">{{ 'popins.products_list.name' | translate }} {{ customerInfos.name }}
            <p class="info">{{ 'popins.products_list.project' | translate }} {{ current.project ? current.project.name :
                ('popins.price_info.placeholder_project' | translate)}}

            <div class="price-table-container">
                <div class="price-table" *ngIf="beautifiedBom">
                    <table>                    
                        <tr>
                            <th>{{ 'popins.products_list.aside.total' | translate }}</th>
                            <td>{{ beautifiedBom.totalPrice + getAssistanceTotalPrice() |
                                currency:'EUR':'symbol':'1.2-2':'fr' }}</td>
                        </tr>
                        <tr>
                            <th>{{ 'popins.products_list.aside.totalTva' | translate }}</th>
                            <td>{{ (getTotalTva(beautifiedBom)) | currency:'EUR':'symbol':'1.2-2':'fr' }}</td>
                        </tr>                                    
                    </table>
                </div>
                
                <div class="detail-price-table">
                    <table>
                        <tr *ngFor="let productCategory of beautifiedBom.totalByCategories">
                            <th>{{ ('popins.products_list.main.'+productCategory.key+'.title') | translate }}</th>
                            <td>{{ productCategory.price | currency:'EUR':'symbol':'1.2-2':'fr' }}</td>
                        </tr>
                        <tr *ngFor="let assistance of assistances">
                            <th class="ecofees">{{ 'popins.products_list.aside.'+ assistance.code | translate }}</th>
                            <td class="ecofees">{{ assistance.price | currency: 'EUR':'symbol':'1.2-2':'fr' }}</td>
                        </tr> 
                    </table>                    
                </div>
                <div class="manage-service" *ngIf="isVendor">
                    <ng-hbm-bdi-btn class="black thin"
                        [label]="'popins.products_list.main.assistance.manage-assistance' | translate"
                        (click)="openAssistances()">
                    </ng-hbm-bdi-btn>
                </div>
            </div>
            <div class="form-group phone">
                <label for="phone">{{ 'popins.products_list.phone' | translate }}</label>
                <input type="text"
                       class="form-control form-control-sm"
                       [placeholder]="'popins.products_list.enterPhone' | translate"
                       id="phone"
                       [(ngModel)]="phoneNumber"
                       (click)="$event.stopPropagation()"
                       (change)="updatePhone($event)">
            </div>

            <div class="legacy" [innerHtml]="disclaimer"></div>
        </div>
    </div>

    <div class="col-9">
        <div class="header-actions">
            <button class="close" (click)="close()" title="{{ 'generic.close' | translate }}">
                <span class="icon-view-close" aria-hidden="true">
                    <svg>
                        <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
                    </svg>
                </span>
                <span>{{ 'generic.close' | translate }}</span>
            </button>
        </div>

        <div class="modal-content-body">

            <div class="init-text pt-5" *ngIf="beautifiedBom.empty">
                {{ 'popins.products_list.empty' | translate }}
            </div>

            <div class="product-list pr-4 pt-5" *ngIf="!beautifiedBom.empty">
                <p *ngIf="isVendor && anyProductNotInStock" class="no-stock">
                    {{ 'popins.products_list.aside.noStock' | translate }}
                </p>
                <table class="table product-table">
                    <ng-container *ngFor="let productBlocks of beautifiedBom.blocks">
                        <tr class="title-row">
                            <td><img width="64" height="64" [src]="productBlocks.thumbnailURLSmall" /></td>
                            <td [attr.colspan]="isVendor ? '10' : '6'" class="text-left"><span
                                    *ngIf="productBlocks.nomenclatureNumber > 0" class="block-number">
                                    M{{ productBlocks.nomenclatureNumber }} - </span>
                                <span>{{ productBlocks.title }} - </span>
                                <span class="block-subtitle">{{ productBlocks.subtitle }}</span>
                            </td>
                            <td class="text-right priceHt">{{ getBlockPriceHt(productBlocks) | currency:'EUR':'symbol':'1.2-2':'fr' }}</td>
                            <td colspan="3"></td>
                            <td class="text-right"><strong>{{ productBlocks.price | currency:'EUR':'symbol':'1.2-2':'fr' }}</strong></td>
                        </tr>
                        <tr class="product-table-label">
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                            <th class="toHidePrint"><span>{{ 'popins.products_list.main.columns.ref' | translate
                                    }}</span></th>
                            <th class="hidden-object">
                                <div class="text-center">{{ 'popins.products_list.main.columns.barcode' | translate }}
                                </div>
                            </th>
                            <th colspan="2">
                                <div class="left">{{ 'popins.products_list.main.columns.name' | translate }}</div>
                            </th>
                            <th class="toHidePrint" *ngIf="isVendor"><span>{{ 'popins.products_list.main.columns.stock'
                                    | translate }}</span></th>
                            <th class="toHidePrint" *ngIf="isVendor"><span>{{
                                    'popins.products_list.main.columns.selectedStore' | translate }}</span></th>
                            <th class="toHidePrint" *ngIf="isVendor">{{
                                'popins.products_list.main.columns.distributionCenter' | translate }}</th>
                            <th class="toHidePrint" *ngIf="isVendor">&nbsp;</th>                            
                            <th><span>{{ 'popins.products_list.main.columns.qty' | translate }}</span></th>
                            <th><span>{{ 'popins.products_list.main.columns.unitPriceHt' | translate }}</span></th>
                            <th><span>{{ 'popins.products_list.main.columns.totalHt' | translate }}</span></th>
                            <th><span>{{ 'popins.products_list.main.columns.tva' | translate }}</span></th>
                            <th><span>{{ 'popins.products_list.main.columns.previousPrice' | translate }}</span></th>
                            <th><span>{{ 'popins.products_list.main.columns.unitPriceTtc' | translate }}</span></th>
                            <th>
                                <div class="text-center"><strong>{{ 'popins.products_list.main.columns.totalTtc' | translate }}</strong>
                                </div>
                            </th>
                        </tr>
                        <tr *ngFor="let productRow of productBlocks.rows; let last = last" [class.last]="last">
                            <td>&nbsp;</td>
                            <td><img width="48" height="48" [src]="productRow.thumbnailURLSmall" /></td>
                            <td class="ref toHidePrint">{{ productRow.reference }}</td>
                            <td class="hidden-object">
                                <svg #barcodeSVG></svg>
                            </td>
                            <td colspan="2">
                                <div class="left">{{ productRow.name }}</div>
                            </td>
                            <td class="toHidePrint" *ngIf="isVendor">
                                <img class="svg-image"
                                    [src]="selectedStoreAvailability(productRow.reference) ? 'assets/img/check.svg' : 'assets/img/cross.svg'"
                                    alt="Check or Cross Image">
                            </td>
                            <td class="toHidePrint" *ngIf="isVendor">{{ selectedStoreStock(productRow.reference,
                                customer.userDatas.storeId) }}</td>
                            <td class="toHidePrint" *ngIf="isVendor">{{ dcStock(productRow.reference) }}</td>
                            <td class="toHidePrint" *ngIf="isVendor">
                                <button class="icon-warehouse">
                                    <fa-icon [icon]="faWarehouse" (click)="displayAllStoreStock(productRow.reference)"
                                        size="lg"></fa-icon>
                                </button>
                            </td>
                            <td>{{ productRow.quantity }}</td>
                            <td>{{ getUnitPriceHt(productRow, productBlocks.rows) | currency:'EUR':'symbol':'1.2-2':'fr' }}</td>
                            <td>{{ getPriceHt(productRow, productBlocks.rows) | currency:'EUR':'symbol':'1.2-2':'fr' }}</td>
                            <td>{{ getTva(productRow, productBlocks.rows) }} %</td>
                            <td><s>{{ getOldPrice(productRow) | currency:'EUR':'symbol':'1.2-2':'fr' }}</s></td>
                            <td><strong>{{ productRow.price.current.value | currency:'EUR':'symbol':'1.2-2':'fr' }}</strong></td>
                            <td>
                                <div class="text-right">
                                    <strong>{{ productRow.totalPrice | currency:'EUR':'symbol':'1.2-2':'fr' }}</strong><span
                                        class="ecofees" *ngIf="productRow.totalDeee > 0"><br />{{
                                        'popins.products_list.aside.totalDeee' | translate }} {{ productRow.totalDeee |
                                        currency:'EUR':'symbol':'1.2-2':'fr' }}</span>
                                    <span class="ecofees" *ngIf="productRow.totalEcomob > 0"><br />{{
                                        'popins.products_list.aside.totalEcomob' | translate }} {{
                                        productRow.totalEcomob | currency:'EUR':'symbol':'1.2-2':'fr' }}</span>
                                </div>
                            </td>
                        </tr>

                        <tr class="spacer" [attr.colspan]="isVendor ? '16' : '12'">
                            <td>&nbsp;</td>
                        </tr>
                    </ng-container>
                </table>
            </div>
        </div>

        <div class="footer">
            <div class="text-right">
                <p class="info-save" *ngIf="!projectIsSaved">{{ 'popins.products_list.infoSave' | translate }}</p>
                <p class="info-save" *ngIf="projectIsLocked">{{ 'popins.products_list.infoLock' | translate }}</p>
                <ng-hbm-bdi-btn class="primary" [disabled]="!projectIsSaved || projectIsLocked"
                    (click)="order()"
                    [label]="isVendor ? ('popins.products_list.cta2' | translate) : ('popins.products_list.cta4' | translate)"></ng-hbm-bdi-btn>
                <ng-hbm-bdi-btn class="primary" [disabled]="beautifiedBom.empty || !projectIsSaved || projectIsLocked"
                    [loading]="printLoading" (click)="printList()"
                    [label]="'popins.products_list.cta' | translate"></ng-hbm-bdi-btn>
            </div>
        </div>
    </div>
</div>